import { fmtCurrency } from '../../../utils/formatNumber';
import styles from '../Reports.module.css';

export default function TrialBalanceReport({ data }) {
  if (!data) return null;
  const { rows, grandTotalDr, grandTotalCr, isBalanced } = data;

  // Group rows by ledger group name, preserving backend order
  const groupMap = {};
  const groupOrder = [];
  (rows || []).forEach((r) => {
    const g = r.groupName || 'Other';
    if (!groupMap[g]) { groupMap[g] = []; groupOrder.push(g); }
    groupMap[g].push(r);
  });

  return (
    <div className="card">
      <div className="card-header"><h3>Trial Balance</h3></div>
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Account Name</th>
              <th className={styles.amtRight}>Debit (₹)</th>
              <th className={styles.amtRight}>Credit (₹)</th>
            </tr>
          </thead>
          <tbody>
            {groupOrder.length === 0 && (
              <tr>
                <td colSpan={3} style={{ textAlign: 'center', color: 'var(--color-text-muted)' }}>
                  No transactions found for this period.
                </td>
              </tr>
            )}

            {groupOrder.map((groupName) => {
              const groupRows = groupMap[groupName];
              const subDr = groupRows.reduce((s, r) => s + r.drBalance, 0);
              const subCr = groupRows.reduce((s, r) => s + r.crBalance, 0);

              return [
                /* Group header */
                <tr key={`hdr-${groupName}`}
                    style={{ background: 'var(--color-primary-bg)' }}>
                  <td colSpan={3}
                      style={{ fontWeight: 700, color: 'var(--color-primary)',
                               fontSize: '0.8rem', textTransform: 'uppercase',
                               letterSpacing: '0.06em', paddingTop: 10, paddingBottom: 10 }}>
                    {groupName}
                  </td>
                </tr>,

                /* Account rows */
                ...groupRows.map((r, i) => (
                  <tr key={`${groupName}-${i}`}>
                    <td style={{ paddingLeft: 24 }}>{r.accountName}</td>
                    <td className={styles.amtRight}>
                      {r.drBalance > 0 ? fmtCurrency(r.drBalance) : <span style={{ color: 'var(--color-text-muted)' }}>—</span>}
                    </td>
                    <td className={styles.amtRight}>
                      {r.crBalance > 0 ? fmtCurrency(r.crBalance) : <span style={{ color: 'var(--color-text-muted)' }}>—</span>}
                    </td>
                  </tr>
                )),

                /* Group sub-total */
                <tr key={`sub-${groupName}`}
                    style={{ background: 'var(--color-surface-raised)', borderTop: '1px solid var(--color-border)' }}>
                  <td style={{ paddingLeft: 24, color: 'var(--color-text-muted)', fontSize: '0.82rem', fontStyle: 'italic' }}>
                    Sub-Total — {groupName}
                  </td>
                  <td className={styles.amtRight} style={{ color: 'var(--color-text-muted)', fontSize: '0.82rem', fontStyle: 'italic' }}>
                    {subDr > 0 ? fmtCurrency(subDr) : '—'}
                  </td>
                  <td className={styles.amtRight} style={{ color: 'var(--color-text-muted)', fontSize: '0.82rem', fontStyle: 'italic' }}>
                    {subCr > 0 ? fmtCurrency(subCr) : '—'}
                  </td>
                </tr>,
              ];
            })}
          </tbody>

          <tfoot>
            <tr>
              <td><strong>Grand Total</strong></td>
              <td className={styles.amtRight}><strong>{fmtCurrency(grandTotalDr)}</strong></td>
              <td className={styles.amtRight}><strong>{fmtCurrency(grandTotalCr)}</strong></td>
            </tr>
            <tr>
              <td colSpan={3}
                  className={isBalanced ? styles.balanceOk : styles.balanceDiff}
                  style={{ textAlign: 'right' }}>
                <strong>
                  {isBalanced
                    ? '✓ Balanced — Debits equal Credits'
                    : `⚠ Difference: ${fmtCurrency(Math.abs(grandTotalDr - grandTotalCr))}`}
                </strong>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}
